import React from 'react'
import {FaBars} from 'react-icons/fa';
import { Nav, NavbarContainer, NavLogo, MobileIcon, NavMenu, NavItem, NavLinks, NavbarDropdown, NavbarDropdownContent, Link} from './NavbarElements';



const Navbar = ({toggle}) => {

  return (
        <Nav>
            <NavbarContainer>
                <NavLogo to="/">
                    <h1>Halo!</h1>
                </NavLogo>
                <MobileIcon onClick={toggle}>
                    <FaBars />
                </MobileIcon>
                <NavMenu>
                    <NavItem>
                        <NavLinks to="about" smooth={true}>ABOUT</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks>
                            <NavbarDropdown>
                                <NavLinks>MATERI</NavLinks>
                                <NavbarDropdownContent>
                                    <NavLinks to="materiA" smooth={true} offset={-70}>AED-A</NavLinks>
                                    <NavLinks to="materiB" smooth={true} offset={-70}>AED-B</NavLinks>
                                    <NavLinks to="materiC" smooth={true} offset={-70}>AED-C</NavLinks>
                                    <NavLinks to="materiD" smooth={true} offset={-70}>AED-D</NavLinks>
                                    <NavLinks to="materiIUP" smooth={true} offset={-70}>AED-IUP</NavLinks>
                                </NavbarDropdownContent>
                            </NavbarDropdown>
                        </NavLinks>   
                    </NavItem>
                    {/* <NavItem>
                        <NavLinks to="tugas" smooth={true}>TUGAS</NavLinks>
                    </NavItem> */}
                    <NavItem>
                        <NavLinks to="contact" smooth={true}>CONTACT</NavLinks>
                    </NavItem>
                </NavMenu>
            </NavbarContainer>
        </Nav>
  )
}

export default Navbar